import React, { useState } from "react";
import "./style.css";
import { MdExpandMore, MdExpandLess } from "react-icons/md";

function Dropdown({
  children,
  placeholder,
  hideDivider,
  placeholderbackground,
  maxHeight,
  defaultOpen = false,
  activeCount = 0,
}) {
  const [show, setShow] = useState(Boolean(defaultOpen));
  const hasActive = Number(activeCount) > 0;

  return (
    <div className="d-flex justify-content-center align-items-center flex-column">
      {!hideDivider ? <div className="divider" /> : null}
      <button
        type="button"
        style={{
          background: placeholderbackground ? "var(--info)" : undefined,
        }}
        onClick={() => setShow((open) => !open)}
        className={`d-flex justify-content-between align-items-center text-capitalize side_bar_header_title dropdown-button${
          hasActive ? " has-active" : ""
        }${show ? " is-open" : ""}`}
        aria-expanded={show}
      >
        <span className="dropdown-button__label">{placeholder}</span>
        <span className="dropdown-button__meta">
          {hasActive ? (
            <span className="dd-filter-section-count">{activeCount}</span>
          ) : null}
          {show ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}
        </span>
      </button>
      {show ? (
        <div
          className={`${placeholderbackground ? "border" : ""} w-100`}
          style={maxHeight ? { maxHeight: "10rem", overflowY: "auto" } : null}
        >
          <div className="expanded-div">{children}</div>
        </div>
      ) : null}
    </div>
  );
}

export default Dropdown;
